
import { Vue, Options } from "vue-class-component";
import TimeSelector from "../components/TimeSelector.vue";
import DistanceSelector from "../components/DistanceSelector.vue";
import PaceOutput from "../components/PaceOutput.vue";
import { Time } from "../models/time";
import * as timeUtil from "../models/time";
@Options({
  components: { TimeSelector, DistanceSelector, PaceOutput },
})
export default class Home extends Vue {
  distance = 0;
  distanceUnit = 1;
  paceUnit = 1;

  private time: Time = { hours: 0, minutes: 0, seconds: 0 };
  private get pace(): Time {
    if (this.distance == 0) {
      return { hours: 0, minutes: 0, seconds: 0 };
    }
    const totalSecondsTime =
      this.time.hours * 3600 + this.time.minutes * 60 + this.time.seconds;
    const totalDistance = this.distance * this.distanceUnit;
    const totalPace = (totalSecondsTime / totalDistance) * this.paceUnit;

    return timeUtil.getTimeFromSecs(totalPace, true);
  }

  get timeMinutes(): number {
    return this.time.minutes;
  }
  set timeMinutes(timeMinutes: number) {
    if (timeMinutes < 60 && timeMinutes >= 0) {
      this.time.minutes = timeMinutes;
    } else {
      this.time.minutes = 59;
    }
  }
  get timeSeconds(): number {
    return this.time.seconds;
  }
  set timeSeconds(timeSeconds: number) {
    if (timeSeconds < 60 && timeSeconds >= 0) {
      this.time.seconds = timeSeconds;
    } else {
      this.time.seconds = 59;
    }
  }
  get timeHours(): number {
    return this.time.hours;
  }
  set timeHours(timeHours: number) {
    this.time.hours = timeHours;
  }
  get paceMinutes(): number {
    return this.pace.minutes;
  }
  get paceSeconds(): number {
    return this.pace.seconds;
  }
  get paceHours(): number {
    return this.pace.hours;
  }
}
